import { BaseWrapper, Button, H5, NavigationWrapper, SectionHeader } from '@base'
import { Devices, Spacings, Text } from '@styles'
import styled, { css, keyframes } from 'styled-components'

export const SpoNavigationWrapper = styled(NavigationWrapper)`
	display: flex;
	align-items: center;
	justify-content: space-between;
`
export const PONavigationWrapper = styled(NavigationWrapper)`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: ${Spacings.SPACING_3B};
`

export const SpoHeaderButtonsWrapper = styled.div`
	padding: ${Spacings.SPACING_2B} 0px;
	display: flex;
	flex-wrap: wrap;
	align-items: baseline;
	justify-content: flex-end;
	@media ${Devices.mobile} {
		flex-wrap: nowrap;
		justify-content: space-between;
	}
`
export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100%;
`
export const PsuedoWrapper = styled.div`
	position: sticky;
	bottom: 0;
	z-index: 1;
	background: ${({ theme }) => theme.palette.background.searchgrey};
	border-top: 1px solid ${({ theme }) => theme.palette.background.searchgrey};

	@media ${Devices.tablet} {
		margin: 0 -${Spacings.SPACING_4B};
	}
`
export const CreateSpoFooter = styled.div`
	background: ${({ theme }) => theme.palette.background.white};
	box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);
	display: flex;
	flex-direction: column;

	position: relative;
`

export const StepperWrapper = styled.div`
	padding: ${Spacings.SPACING_3B};
	border-bottom: 1px solid ${({ theme }) => theme.palette.background.searchgrey};
`
export const FullFlexWrapper = styled.div`
	@media ${Devices.tablet} {
		border-radius: ${Spacings.SPACING_2B};
		margin-bottom: ${Spacings.SPACING_4B};
	}
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_4B};
`

export const SectionWrapper = styled(BaseWrapper)`
	padding: ${Spacings.SPACING_2B};
`

export const SPOFormContainer = styled.div`
	padding: ${Spacings.SPACING_2B} 0px;
	display: flex;
	flex-wrap: wrap;
	align-items: baseline;
	justify-content: flex-end;
	@media ${Devices.mobile} {
		flex-wrap: nowrap;
		justify-content: space-between;
	}
`

export const DesktopAmountSection = styled.div`
	display: none;
	@media ${Devices.tablet} {
		display: initial;
		min-width: 17rem;
		width: 17rem;
		margin-left: ${Spacings.SPACING_6B};
		border-radius: ${Spacings.SPACING_2B};
		height: fit-content;
	}
`

export const TotalAmountSection = styled.div`
	padding: ${Spacings.SPACING_3B};
	display: flex;
	user-select: none;
	border-bottom: 1px solid ${({ theme }) => theme.palette.background.searchgrey};

	@media ${Devices.tablet} {
		padding: 0 0 ${Spacings.SPACING_4B} 0;
	}
`

export const FlexWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

export const Label = styled.span`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.label};
	display: inline-block;
	margin-bottom: ${Spacings.SPACING_2B};
`

export const PartialAmountWrapper = styled(FlexWrapper)`
	padding: ${Spacings.SPACING_2B};
	border-radius: ${Spacings.SPACING_2B};
	background: ${({ theme }) => theme.palette.background.pill};
	margin-bottom: ${({ margin }) => margin || Spacings.SPACING_2B};
`

export const Amount = styled.span`
	font-weight: ${Text.BOLD_600};
	line-height: ${Text.LINE_HEIGHT_MAX};
`

export const bounce = keyframes`
0% {
    padding-bottom: 0;
}
20% {
    padding-bottom: 4px;
}
30% {
    padding-bottom: 8px;
}
40% {
    padding-bottom: 12px;
}
50% {
    padding-bottom: 16px;
}
60% {
    padding-bottom: 12px;
}
70% {
    padding-bottom: 8px;
}
80% {
    padding-bottom: 4px;
}
100% {
    padding-bottom: 0;
}

`

export const InfoPanel = styled.div`
	min-height: ${({ show }) => (show ? '18rem' : '0')};
	max-height: ${({ show }) => (show ? '28rem' : '0')};
	border-bottom: 1px solid ${({ show, theme }) => (show ? theme.palette.background.searchgrey : theme.palette.background.white)};

	transition: all 0.15s ease-in-out;
	overflow-y: scroll;

	/* Hide scrollbar for Chrome, Safari and Opera */
	&::-webkit-scrollbar {
		display: none;
	}
	/* Hide scrollbar for IE, Edge and Firefox */
	& {
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
	}

	padding: ${({ show }) => (show ? `${Spacings.SPACING_4B} ${Spacings.SPACING_3B}` : `0 ${Spacings.SPACING_3B}`)};

	${({ amountPanelAnimation }) => {
		if (amountPanelAnimation) {
			return css`
				animation-name: ${bounce};
				animation-duration: 0.8s;
				animation-iteration-count: infinite;
				animation-timing-function: ease-in;
				animation-fill-mode: forwards;
			`
		}
	}}

	@media ${Devices.tablet} {
		min-height: fit-content;
		max-height: fit-content;
		padding: ${Spacings.SPACING_4B} 0;
		border: none;
		animation: none;
	}
`

export const Heading = styled(H5)`
	@media ${Devices.tablet} {
		margin-bottom: ${Spacings.SPACING_3B};
	}
`

export const SectionBody = styled.div`
	display: flex;
`

export const ItemsWrapper = styled.div`
	flex-grow: 1;
`

export const ActionButton = styled(Button)`
	margin-left: ${Spacings.SPACING_4B};
	max-width: 14rem;

	&:last-of-type {
		margin-left: 0;
	}

	// text-transform: uppercase;
	flex-grow: 1;

	@media ${Devices.tablet} {
		flex-grow: 0;
	}

	margin: ${({ margin }) => margin};
`

export const FormWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	border-radius: ${Spacings.SPACING_2B};
`

export const SectionItemWrapper = styled.div`
	flex-shrink: unset;
	flex-basis: 100%;
	height: 100%;
	margin-top: ${Spacings.SPACING_2B};

	& > div {
		width: 100%;
	}
`
export const BiInputWrapper = styled.div`
	display: grid;
	grid-template-columns: 4fr 2fr;
	column-gap: ${Spacings.SPACING_2B};
`

export const SectionItemWrapperWithTwoItems = styled(SectionItemWrapper)`
	display: flex;
	align-items: flex-end;

	& > div {
		flex-grow: 1;
		flex-basis: 50%;
		&:nth-child(2) {
			margin: 0px ${Spacings.SPACING_2B};
		}
	}
`

export const FormElementLabel = styled.label`
	font-size: 0.75rem;
	display: block;
	margin-left: 8px;
	color: ${({ disabled, theme }) => (disabled ? theme.palette.text.greydark : theme.palette.text.black)};
	cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
	user-select: none;
`

export const SubSectionWrapper = styled.div`
	padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_4B};
	background: ${({ theme }) => theme.palette.background.white};
	box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);
	@media ${Devices.tablet} {
		border-radius: ${Spacings.SPACING_2B};
	}
`

export const LeftButtonsWrapper = styled.div`
	display: flex;
	justify-content: start;
	flex: 1;
`

export const RightButtonsWrapper = styled.div`
	display: flex;
	justify-content: end;
	flex: 1;
	align-items: center;
`

export const SingleItemWrapper = styled.div`
	max-width: 20rem;
	padding-top: ${Spacings.SPACING_1B};
`

export const FormELementLabelWrapper = styled.label`
	font-size: 0.75rem;
	display: block;
	margin-left: 8px;
	color: ${({ disabled, theme }) => (disabled ? theme.palette.text.greydark : theme.palette.text.black)};
	cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
	user-select: none;
`
export const CheckboxWrapper = styled.div`
	display: flex;
	width: fit-content;
	padding: ${Spacings.SPACING_2B};
`
export const SubsectionHeader = styled(SectionHeader)`
	margin-top: ${Spacings.SPACING_5B};
	justify-content: flex-end;
`

export const SPOFormButtonWapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	@media ${Devices.mobile} {
		flex-wrap: nowrap;
	}
	gap: ${Spacings.SPACING_2B};
`
